import { IconProps } from '@/components/Icon';

export const IconAddPerson = ({ width = 16, height = 16, color = 'currentColor', ...props }: IconProps) => {
  return (
    <svg {...props} fill='none' height={height} viewBox='0 0 16 16' width={width} xmlns='http://www.w3.org/2000/svg'>
      <path
        clipRule='evenodd'
        d='M8.21,1.42c-1.6,0-3.08.56-4.24,1.51h1.23c.29,0,.52.23.52.52s-.23.52-.52.52h-1.29v1.29c0,.29-.23.52-.52.52s-.52-.23-.52-.52v-1.2c-.87,1.14-1.39,2.56-1.39,4.09,0,3.71,3.02,6.73,6.73,6.73s6.73-3.02,6.73-6.73S11.92,1.42,8.21,1.42ZM6.58,5.2c.41-.43.99-.67,1.63-.67s1.21.24,1.62.68c.42.44.62,1.04.57,1.68-.1,1.27-1.08,2.31-2.19,2.31s-2.1-1.04-2.19-2.31c-.05-.64.16-1.24.57-1.68ZM8.21,13.85c-1.54,0-3.01-.62-4.08-1.72.3-.43.69-.8,1.14-1.08.83-.53,1.87-.82,2.94-.82s2.12.29,2.94.82c.45.28.83.65,1.14,1.08-1.07,1.1-2.54,1.72-4.08,1.72ZM2.87,4.06v-.1h-1.29c-.29,0-.52-.23-.52-.52s.23-.52.52-.52h1.29v-1.29c0-.29.23-.52.52-.52s.52.23.52.52v1.29h.07c-.41.33-.78.71-1.1,1.13Z'
        fill={color}
        fillRule='evenodd'
      />
    </svg>
  );
};
